<template>
  <ul class="nav nav-tabs tabs-bordered">
    <li v-for="item in dataItems" :key="item.to.name" :class="itemClass(item)">
      <router-link :to="item.to" data-toggle="tab" role="tab">
        {{ item.display }}
      </router-link>
    </li>
  </ul>
</template>
<script setup lang="ts">
import { ref, watch } from "vue";
import { useRoute } from "vue-router";

defineProps<{ dataItems: { to: { name: string }; display: string }[] }>();

const route = useRoute();
const from = ref(route);
watch(
  () => route,
  (route) => (from.value = route),
);

function itemClass(item) {
  return item.to.name === from.value.name ? "active" : undefined;
}
</script>
